export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-05-28 at 11.49.12 PM - 018_AYSHI BHOWMIK.94439a4f.jpeg";